import { Button } from '../../design-system/primitives/index.js';
import SwatchGrid from './SwatchGrid.jsx';
import { formatRecipeCount, packRecipeCount } from './packRecipeCount.js';
import './RecipePacks.css';

/**
 * PackDetailContent — shared body for both PackDetailModal (desktop) and
 * PackDetailSheet (mobile). Differs only in padding via the `compact` prop.
 */
export default function PackDetailContent({ pack, added, onClose, onAdd, compact = false }) {
  const recipeCount = packRecipeCount(pack);
  return (
    <>
      {/* Header */}
      <div className="rp-detail-header" data-compact={compact || undefined}>
        <div className="rp-detail-header-top">
          <div className="eyebrow rp-detail-eyebrow">Curated pack · {formatRecipeCount(recipeCount)}</div>
          <button
            onClick={onClose}
            aria-label="Close pack detail"
            className="rp-detail-close"
          >×</button>
        </div>
        <div className="rp-detail-hero">
          <div className={`rp-detail-swatch-wrap ${compact ? 'rp-detail-swatch-wrap--compact' : 'rp-detail-swatch-wrap--full'}`}>
            <SwatchGrid swatches={pack.swatches} size={compact ? 'lg' : 'xl'} />
          </div>
          <div className="rp-detail-hero-text">
            <h2 className={`rp-detail-name ${compact ? 'rp-detail-name--compact' : 'rp-detail-name--full'}`}>{pack.name}</h2>
            <div className="rp-detail-blurb">{pack.blurb}</div>
            <div className="rp-detail-tag-row">
              <span className="chip rp-chip-sm">{pack.tag}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Recipe rows */}
      <div className="rp-detail-recipes" data-compact={compact || undefined}>
        <div className="eyebrow rp-detail-section-eyebrow">What you'll get</div>
        {pack.recipes.map((r, i) => (
          <div
            key={r.id || i}
            className="rp-detail-recipe-row"
          >
            <div className={`recipe-img ${r.img} rp-detail-recipe-thumb`} />
            <div className="rp-detail-recipe-info">
              <div className="rp-detail-recipe-name">{r.name}</div>
              <div className="rp-detail-recipe-uses">Uses {r.uses}</div>
            </div>
            <div className="rp-detail-recipe-meta">
              <div className="rp-detail-recipe-time">{r.time}</div>
              <div className="rp-detail-recipe-style">{r.style}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Footer CTA */}
      <div className="rp-detail-footer" data-compact={compact || undefined}>
        <div className="rp-detail-footer-note">
          Added recipes appear in Browse with a{' '}
          <b className="rp-detail-from-name">from {pack.name}</b>{' '}
          tag, so you can remove the pack later.
        </div>
        {added ? (
          <Button type="button" variant="secondary" className="rp-detail-cta" disabled>
            ✓ Already with your recipes
          </Button>
        ) : (
          <Button type="button" variant="primary" className="rp-detail-cta" onClick={onAdd}>
            Add {recipeCount} recipes
          </Button>
        )}
      </div>
    </>
  );
}
